import { useEffect } from "react";
import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";

import innerStyles from "./universalHeader.module.css";

export default function UniversalHeader({
  options,
  mode,
  styles,
  register,
  unregister,
  newData,
  control,
  setValue,
  errors,
  handleCustomButton,
  clearErrors,
  getValues,
}) {
  const combiningDataFromArray = (value, options) => {
    let resultValue = "";
    value.forEach((item, index) => {
      let optionValue = options.find((elem) => elem.value === item)?.label;
      resultValue += index === value.length - 1 ? optionValue : `${optionValue}, `;
    });
    return resultValue;
  };
  return (
    <div>
      {mode === "add" || mode === "edit" ? (
        <div className={innerStyles["component-container"]}>
          <div className={`${innerStyles["inputs-container"]}`}>
            <div className={styles[options.gridKey]}>
              {Object.values(options.inputsOptions).map((item) =>
                item?.needInForm ? (
                  item.fieldModeView ? (
                    <div
                      key={item.key}
                      className={innerStyles["text-block"]}>
                      <p className={innerStyles["option-label"]}>{item.label}</p>
                      <p className={innerStyles["option-value"]}>
                        {item.type === "selectWithSearch"
                          ? Array.isArray(newData?.[item.key])
                            ? combiningDataFromArray(newData?.[item.key], item.options)
                            : item.options.find((elem) => elem.value === newData?.[item.key])?.label || "—"
                          : item.type === "date" && newData?.[item.key]
                          ? newData?.[item.key].split("-").reverse().join(".")
                          : newData?.[item.key] || "—"}
                      </p>
                    </div>
                  ) : (
                    <InputsCreatorUniversal
                      key={item.key}
                      option={item}
                      styles={styles}
                      register={register}
                      unregister={unregister}
                      newData={newData}
                      control={control}
                      setValue={setValue}
                      getValues={getValues}
                      mode={mode}
                      errors={errors}
                      clearErrors={clearErrors}
                      handleCustomButton={handleCustomButton}
                    />
                  )
                ) : null,
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={innerStyles["component-container"]}>
          <div className={`${innerStyles["inputs-container"]}`}>
            <div className={styles[options.gridKey]}>
              {Object.values(options.inputsOptions).map(
                (item) =>
                  item?.needInForm && (
                    <div
                      key={item.key}
                      className={innerStyles["text-block"]}>
                      <p className={innerStyles["option-label"]}>{item.label}</p>
                      <p className={innerStyles["option-value"]}>
                        {item.type === "selectWithSearch"
                          ? item.options.find((elem) => elem.value === newData?.[item.key])?.label || "—"
                          : item.type === "date" && newData?.[item.key]
                          ? newData?.[item.key].split("-").reverse().join(".")
                          : newData?.[item.key] || "—"}
                      </p>
                    </div>
                  ),
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
